export const API_EXTERNAL_ENDPOINT = 'cottages/recommended-by-cottage/:id'

export const API_INTERNAL_ENDPOINT =
  'rurality/v3/cottages/recommended-by-cottage/detail'
